import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BiLoaderAlt } from 'react-icons/bi';
import dayjs from 'dayjs';

import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import {
  getSalesPromoCodeAnalysis,
  SalesActions,
  useAccountDispatch,
  useAccountSelector,
} from '@wajeez-web/stores/account';
import { ButtonHeadless, Spin } from '@wajeez-web/components/ui';
import {
  FormDateInput,
  FormSelectInput,
} from '@wajeez-web/components/form-builder';
import { Server } from '@wajeez/wajeez.microservices';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import {
  convertLocalDateTimeToEnd,
  convertLocalDateTimeToZero,
  getLocalTimeFromUTC,
} from '@wajeez-web/core/utils';
import { useGetUtilityPromoCodeAnalysis } from '@wajeez-web/components/helpers';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { useTranslation } from 'react-i18next';

// type Input = GetSalesPromoCodeAnalysisInput;

// const fromDateDefault = convertLocalDateTimeToZero(
//   dayjs(new Date()).subtract(7, 'day')
// );

// const toDateDefault = convertLocalDateTimeToEnd(dayjs(new Date()));

export const SalesPromoCodeAnalysisPage = () => {
  const accountDispatch = useAccountDispatch();

  const [isDefaultFetch, setIsDefaultFetch] = useState(true);

  const salesPromoCodeAnalysis = useGetUtilityPromoCodeAnalysis();

  const { t } = useTranslation();

  // const { handleSubmit, control } = useForm<Input>({
  //   defaultValues: {
  //     fromDate: fromDateDefault,
  //     toDate: toDateDefault,
  //   },
  // });

  // const onSubmit: SubmitHandler<Input> = async (data) => {
  //   getSalesPromoCodeAnalysis(data);
  // };

  useEffect(() => {
    if (isDefaultFetch) {
      getSalesPromoCodeAnalysis(undefined, () => {
        setIsDefaultFetch(false);
      });
    }
  }, [accountDispatch, isDefaultFetch]);

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Sales Promo Code Analysis`}
        withoutRightPadding={false}
        breadCrumbsLinks={[{ title: 'Sales Promo Code Analysis' }]}
      >
        <div className="w-full pt-2 pb-4 rtl:pl-8 ltr:pr-8">
          {/* <div className="flex justify-between items-center">
            <form
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              // className="order-1"
            >
              <h1 className="text-[24px] font-bold">
                <ReturnTranslatedText
                  text={`general.${'Filters'}`}
                  origintext="Filters"
                />
              </h1>
              <div className="w-full flex flex-col justify-start items-start space-y-2">
                <div className="w-full flex justify-start items-center space-s-2">
                  <div className="w-[300px]">
                    <FormDateInput
                      name="fromDate"
                      control={control}
                      fieldType={{
                        fieldType: Server.FieldType.Date,
                        fieldOptions: {},
                        label: 'From Date',
                        required: true,
                      }}
                      widthClassName="w-full"
                      controlled
                    />
                  </div>
                  <div className="w-[300px]">
                    <FormDateInput
                      name="toDate"
                      control={control}
                      fieldType={{
                        fieldType: Server.FieldType.Date,
                        fieldOptions: {},
                        label: 'To Date',
                        required: true,
                      }}
                      widthClassName="w-full"
                      controlled
                      endOfDay
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 w-[100px]">
                <ButtonHeadless
                  type="submit"
                  borderStyle="border-none"
                  paddingYStyle="py-[6px]"
                  borderRadiusStyle="rounded-[6px]"
                  isDisabled={salesPromoCodeAnalysis.status === 'loading'}
                >
                  <div className="text-white text-[16px] font-medium flex justify-center items-center space-s-2">
                    <ReturnTranslatedText
                      text="buttons.Generate"
                      origintext="Generate"
                    />
                    {!isDefaultFetch &&
                      salesPromoCodeAnalysis.status === 'loading' && (
                        <BiLoaderAlt className="animate-spin w-5" />
                      )}
                  </div>
                </ButtonHeadless>
              </div>
            </form>
          </div> */}
          {
            <div className="mt-8">
              <ChartDisplay
                chartType="area"
                seriesData={[
                  {
                    data: salesPromoCodeAnalysis.data?.items?.length
                      ? salesPromoCodeAnalysis.data?.items?.map((t) => {
                          return {
                            x: getLocalTimeFromUTC(t.startDate || '') || '',
                            y: t.count || 0,
                          };
                        })
                      : [],
                  },
                ]}
                noDataText={t(`general.${'No Data'}`, 'No Data') || ''}
              />
            </div>
          }
        </div>
      </PageLayoutsContainer>
    </div>
  );
};
